import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject, type OnDestroy } from '@angular/core';
import { PorscheDesignSystemModule, ToastManager } from '@porsche-design-system/components-angular';
import { BehaviorSubject, distinctUntilChanged, tap } from 'rxjs';
import { SubSink } from 'subsink';
import type { EduExpenseCategory } from '../../../shared/models/api/edu-expense-category.model';
import { EduExpenseCategoryService } from '../../../shared/services/api/edu-expense-category.service';

@Component({
  selector: 'opa-edu-expense-category-delete',
  imports: [CommonModule, PorscheDesignSystemModule],
  templateUrl: './edu-expense-category-delete.component.html',
  styleUrl: './edu-expense-category-delete.component.scss',
})
export class EduExpenseCategoryDeleteComponent implements OnDestroy {
  private readonly eduExpenseCategoryService = inject(EduExpenseCategoryService);
  private readonly toastManager = inject(ToastManager);

  @Input({ required: true }) open = false;
  @Input({ required: true }) eduExpenseCategory: EduExpenseCategory | undefined = undefined;
  @Output() dismiss = new EventEmitter<EduExpenseCategory | undefined>();

  private readonly subSink = new SubSink();
  private readonly submitting = new BehaviorSubject(false);
  readonly submitting$ = this.submitting.pipe(distinctUntilChanged());

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  close(eduExpenseCategory?: EduExpenseCategory): void {
    this.dismiss.emit(eduExpenseCategory);
  }

  submit(): void {
    const eduExpenseCategory = this.eduExpenseCategory;
    if (!eduExpenseCategory) return;

    this.submitting.next(true);
    this.subSink.sink = this.eduExpenseCategoryService
      .deleteEduExpenseCategory(eduExpenseCategory.id)
      .pipe(
        tap({
          next: () => {
            this.toastManager.addMessage({
              text: `Category ${eduExpenseCategory.name} deleted`,
              state: 'success',
            });
            this.submitting.next(false);
            this.dismiss.emit(eduExpenseCategory);
          },
          error: () => this.submitting.next(false),
        }),
      )
      .subscribe();
  }
}
